import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";

const route = "/docente/v1/bloqueios-plano-atividade";

function getValidateDataLock(instance: IPublicClientApplication) {
    return axiosGetRequest(
        `${route}/valida-data-bloqueio`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getValidateDataLock,
};
